import React from 'react'
import ReactDom from 'react-dom'
import unitmap from '@engrain/unitmap'
import classNames from 'classnames'

class FloorPicker extends React.Component {

  constructor(props) {
    super(props)

    const {
      currentFloor,
      input
    } = this.props

    this.floors = input.options

    this.floors.forEach((floor, index) => {
      floor['count'] = 0
    })

    this.unitmap = null
    this.state = {
        floorsWithAvailableUnits: []
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    const {
      config,
      currentFloor,
      document
    } = this.props

    this.unitmap = unitmap(this.refs.floorPicker, {
        autoScale: 'width',
        panZoom: false
    })

    if (this.props.onFloorPicker) {
      this.props.onFloorPicker({floorPicker: this.unitmap})
    }

    if (document) {
      this.unitmap.document(document.toJS())

      this.setAllFloorsTo(config.unitmap.style.noCriteria)

      this.highlightFloorsWithMatchingUnits(this.props)

      this.setSelectedFloor(currentFloor)

      this.unitmap.on('hitarea:click', (event) => {
        const {
          currentFloor
        } = this.props

        event.originalEvent.preventDefault()
        let target = event.hitarea.target()

        let floor = target.id

        if (floor !== currentFloor) {
            this.handleChange(floor)
        }
      })

      this.unitmap.on('hitarea:mouseover', (event) => {
        const {
          config,
          currentFloor
        } = this.props
        let target = event.hitarea.target()
        let floor = target.id

        if (floor !== currentFloor) {
          target.color(config.unitmap.style.mouseOver)
        }
      })

      this.unitmap.on('hitarea:mouseout', (event) => {
        const {
          config,
          currentFloor
        } = this.props
        let target = event.hitarea.target()
        let floor = target.id

        let indexOfFloorHasAvailableUnit = this.state.floorsWithAvailableUnits.indexOf(floor)

        if (floor !== currentFloor) {
          if (indexOfFloorHasAvailableUnit !== -1) {
            target.color(config.unitmap.style.allCriteria)
          } else {
            target.color(config.unitmap.style.noCriteria)
          }
        }
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.config !== this.props.config
    || nextProps.currentFloor !== this.props.currentFloor
    || nextProps.document !== this.props.document
    || nextProps.height !== this.props.height
    || nextProps.image !== this.props.image
    || nextProps.input !== this.props.input
    || nextProps.units !== this.props.units
  }

  componentWillUpdate(nextProps, nextState) {
    const {
      config,
      currentFloor
    } = nextProps

    this.setAllFloorsTo(config.unitmap.style.noCriteria)

    this.highlightFloorsWithMatchingUnits(nextProps)

    this.setSelectedFloor(currentFloor)
  }

  handleChange(floor) {
    if (this.props.onChange) {

      const {
        input
      } = this.props
      this.props.onChange({
        valueFor: input.valueFor,
        value: floor
      })
    }
  }

  highlightFloorsWithMatchingUnits(props) {
    const {
      config,
      units
    } = props

    let floorsWithAvailableUnits = []
    this.floors.forEach((floor) => {
      if (units.filter((unit) => (floor.value === unit.floor)).length) {
        floorsWithAvailableUnits.push(floor.value)
      }
    })

    // highlight floors with an unit matching the filters
    if (floorsWithAvailableUnits !== [] && this.unitmap !== null) {
      // get all floors (which are called units [of measure] in the unitmap)
      let all_floors = this.unitmap.select('units')

      // change color filtered units
      all_floors.find(floorsWithAvailableUnits).color(config.unitmap.style.allCriteria)
    }

    this.setState({floorsWithAvailableUnits: floorsWithAvailableUnits})
  }

  setAllFloorsTo(color) {
    if (this.unitmap !== null) {
      let {
        config
      } = this.props

      // get all floors (which are called units [of measure] in the unitmap)
      let all_floors = this.unitmap.select('units')

      // set all units to clear
      all_floors.color(config.unitmap.style.noCriteria)
    }
  }

  setSelectedFloor(floor) {
    if (this.unitmap !== null) {
      let {
        config
      } = this.props

      // get all floors (which are called units [of measure] in the unitmap)
      let all_floors = this.unitmap.select('units')

      // change color filtered units
      all_floors.find(floor).color(config.unitmap.style.selectedFloor)
    }
  }

  render() {
    let {
      config,
      height,
      width
    } = this.props

    return (
    <div id="floor-picker">
      <div className="unit-map-panel" style={{width, height}} ref="floorPicker">
        <img src={config.image}/>
      </div>
    </div>
    )
  }
}

FloorPicker.defaultProps = {
  config: null,
  currentFloor: null,
  document: null,
  input: {},
  width: '100%',
  height: '100%'
}

export default FloorPicker
